<template>
  <div>
    <el-dialog
      title="公告审批流设置提示"
      :visible.sync="dialogVisibleV"
      width="600px"
      :modal-append-to-body="false"
    >
      <div v-if="isAdmindialog">
        <p>
          开展业务前，需设置处置公告审批流，<span class="link" @click="link"
            >去设置</span
          >
        </p>
        <br />
        <p>公告审批流设置后，如需调整可点击菜单“公告审批设置”修改</p>
      </div>
      <div v-else>
        <p>需配置公告审批，请联系您公司系统管理员进行配置</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibleV = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <div class="account" v-if="showV">
      <div class="account-aside">
        <el-menu
          router
          :default-openeds="openeds"
          @select="onMenuSelect"
          :default-active="$route.meta.activeName"
        >
          <el-submenu index="1">
            <template slot="title">处置服务</template>
            <el-menu-item index="ServiceCompileMaterial"
              >编制处置公告</el-menu-item
            >
            <!-- <el-menu-item index="ServiceForetellManagement"
              >处置预告管理</el-menu-item
            > -->
            <el-menu-item index="ServiceContractsManagement"
              >处置公告管理</el-menu-item
            >
            <!-- <el-menu-item index="ServiceForetellApprove"
              >审批处置预告</el-menu-item
            > -->
            <el-menu-item index="ServiceApprove" v-if="auditerWhether"
              >审批处置公告</el-menu-item
            >
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">处置异常管理</template>
            <el-menu-item index="ServiceException">处置异常处理</el-menu-item>
            <el-menu-item index="ServiceExceptionApprove"
              >处置异常审批</el-menu-item
            >
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">订单管理</template>
            <el-menu-item index="ServiceManagement">我的订单</el-menu-item>
          </el-submenu>
          <el-submenu index="5">
            <template slot="title">公告审批设置</template>
            <el-menu-item index="ServiceApprovalSetting"
              >公告审批设置</el-menu-item
            >
          </el-submenu>
        </el-menu>
      </div>
      <div class="account-container" v-cloak>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Default',
  components: {},
  directives: {},
  filters: {},
  mixins: {},
  props: {
    propName: {
      // type: number,
      // default: 0
    }
  },
  data() {
    return {
      dialogVisibleV: false,
      isAdminFlag: true,
      isAdmin: null,
      isAdmindialog: true,
      dialogVisible: false,
      auditerWhether: '',
      openeds: ['1', '2', '3', '4', '5', '6'],
      active: '',
      falg: true,
      showV: true
      // key: value
    }
  },
  computed: {
    logo() {
      return this.$route.query.logo
    }
  },
  watch: {},
  created() {
    this.onMenuSelect()
    this.serveProviderCheck()
    this.sellerAuditGet()
  },
  methods: {
    link() {
      this.$router.push({ name: 'ServiceApprovalSetting' })
      this.dialogVisibleV = false
    },
    onMenuSelect(index) {
      this.active = index
    },
    async serveProviderCheck() {
      let data = await this.$api.serviceProvider.serveProviderCheck()
      if (data) {
        this.auditerWhether = data.auditerWhether
        if (data.auditerWhether != 1 && this.$route.name == 'ServiceApprove') {
          this.$router.push({ name: 'Home' })
        }
      }
    },
    async sellerAuditGet() {
      let data = await this.$api.serviceProvider.getAudit()
      if (data) {
        if (data.auditLevel === null) {
          this.dialogVisibleV = true
        } else {
          this.dialogVisibleV = false
        }
      }
    }
  }
}
</script>
<style lang="less">
.account {
  display: flex;
  margin-top: 20px;
  .el-submenu__title i {
    color: #ffffff;
  }
  .account-aside {
    width: 18%;
    padding-bottom: 40px;
    margin-right: 20px;
    .el-menu {
      border-right: none;
      .el-submenu__title {
        background: #2587ff;
        height: 40px;
        line-height: 40px;
        color: #ffff;
      }
      .el-menu-item {
        height: 40px;
        line-height: 40px;
      }
    }
  }
  .account-container {
    // width: 100%;
    // flex: 1;
    width: 80%;
    min-height: calc(100vh - 315px);
    // padding: 40px 30px;
  }
}
.link {
  color: cornflowerblue;
  cursor: pointer;
}
[v-cloak] {
  display: none;
}
</style>
